import Vue, { createApp } from 'vue'
import Antd from 'ant-design-vue'
import App from './App'
import router from './router'
import store from './store'
import 'ant-design-vue/dist/antd.less'
import '@/plugins/'
import SvgIcon from './components/svg-icon'
import '@/icon'
import i18n from './locales'
// import systemMessage from './utils/systemMessage'
/**
 * @description 正式环境默认使用mock，正式项目记得注释后再打包
 */
// if (process.env.NODE_ENV === 'production') {
//   const { mockXHR } = require('@/utils/static')
//   mockXHR()
// }
const app = createApp(App).use(store).use(router).use(Antd).use(i18n)
// 系统消息框
// app.use(systemMessage)

// 引入SvgIcon组件
app.component('svg-icon', SvgIcon)
app.mount('#app')
store.dispatch(
  'settings/changeLanguage',
  localStorage.getItem('lang') || 'en-US'
)
